import { immerable } from "immer";

export class RangeModifier {
    [immerable] = true;
    from: Date | null = null;
    to: Date | null = null;
    useClientUserLocalTimezone = false;

    constructor(init?: Partial<RangeModifier>) {
        this.from = init?.from ?? null;
        this.to = init?.to ?? null;
        this.useClientUserLocalTimezone = init?.useClientUserLocalTimezone ?? false;
    }
}
